<template>

    <div class="page-swipe">
       <van-nav-bar
        :title="titleName()"
        left-arrow
        @click-left="$emit('cancel', $event)"
      />
      <p class="tip">为保障业务的顺利进行，请如实填写参保人信息。以下信息只用于本业务办理，绝不泄露或他用。</p>
      <form @submit.prevent="onSubmit">
        <div class="profile-box">

          <van-cell-group>
              <van-field
                name="name"
                :disabled="isEditoInfo"
                v-model="name"
                label="参保人姓名"
                placeholder="请输入姓名"
                v-validate="'required|min:2|max:5'"
                clearable
                @blur="clearScroll()"
              />

            <van-field
                name="id_number"
                v-model="id_number"
                label="身份证号码"
                placeholder="请输入身份证号码"
                v-validate="'required|length:15,18'"
                v-bind:readonly="hasEditProfile"
                v-bind:clearable="!hasEditProfile"
                @click="hasEditProfile ? $toast('身份证不允许修改') : ''" 
                 @blur="clearScroll()"
              />
           
           <!--
             <van-field
                name="hukou"
                readonly
                v-model="hukou.value"
                label="户口性质"
                placeholder="请选择"
                :disabled="isEditoInfo"
                @click="hukou.show = true"
              />

          <van-actionsheet v-model="hukou.show"
            :actions="hukou.actions" get-container=".page-wrap"/>
            -->

            <van-field
                name="phone"
                v-model="phone"
                label="参保人手机"
                placeholder="请输入参保人手机"
                v-validate="'required|length:11'"
                clearable
                 @blur="clearScroll()"
              />
          </van-cell-group>
          <!--

          <van-cell-group style="margin-top: 10px;">
              <van-field
                name="relation"
                readonly
                v-model="relation"
                label="与本人关系"
                placeholder="不填默认为本人"
                clearable
                @click="relationSheet = true"
              />
          </van-cell-group>
              -->



          <!-- <van-cell-group >
            <van-row class="">
              <van-col span="12" class="">
                <van-uploader :after-read="onImageRead" accept="image/gif, image/jpeg, image/png">
                  <span class="upload-icon">点击上传图片</span>

                  <img :src="testImg" alt="" >
                </van-uploader>
              </van-col>
              <van-col span="12" class="">

              </van-col>
            </van-row>
          </van-cell-group> -->

<!--
          <van-cell-group class="photos-box">
            <span class="photo-label">身份证照片上传(可选)</span>
            <van-row gutter="20" class="photo-row first" v-if="$cfg.sbyUploader">
              <van-col span="12" class="photo-van">
                  <sby-uploader tip="身份证正面照片" :previewData="idFront" v-on:upload="idFront = $event"
                    :preview="true" class="a-upload" :afterRead="onFrontChoose"></sby-uploader>
                </van-col>
                <van-col span="12" class="photo-van">
                  <sby-uploader tip="身份证背面照片" :previewData="idBack" v-on:upload="idBack = $event"
                    :preview="true" class="a-upload" :afterRead="onBackChoose"></sby-uploader>
                </van-col>
            </van-row>
            
            <van-row gutter="20" class="photo-row first" v-else>
              <van-col span="12" class="photo-van">
                <a href="javascript:;" class="a-upload">
                  <img :src="idFront" alt="" v-if="idFront" class="preview"> 
                  <div class="photo-box" v-else>
                    <img src="../assets/images/plus@.png" class="img-tip" alt="">
                    <p>身份证正面照片</p>
                  </div>
                  <input type="file" name="id-front-image" class="id-front-image" accept="image/*"  @change.prevent="choosePhoto"/>
                </a>
              </van-col>
              <van-col span="12" class="photo-van">
                <a href="javascript:;" class="a-upload">
                  <img :src="idBack" alt="" v-if="idBack" class="preview"> 
                  <div class="photo-box" v-else>
                    <img src="../assets/images/plus@.png" class="img-tip" alt="">
                    <p>身份证背面照片</p>
                  </div>
                  <input type="file" name="id-back-image" class="id-back-image" accept="image/*"  @change.prevent="chooseBackPhoto"/>
                </a>
              </van-col>
            </van-row>

            <span class="photo-label">示例</span>
            <van-row gutter="20" class="photo-row">
              <van-col span="12" class="photo-van">
                <div class="photo-box">
                  <img src="../assets/images/id-front.png" class="img-id" alt=""/>
                </div>
              </van-col>
              <van-col span="12" class="photo-van">
                <div class="photo-box">
                  <img src="../assets/images/id-back.png" class="img-id" alt=""/>
                </div>
              </van-col>
            </van-row>

            <div class="tips">
            注意：<br/>
            1. 位于身份证正反两面上方拍摄，身份证填充照片整个区域，字体清晰；<br/>
            2. 目前仅支持5M以内的jpg、png、jpeg格式图片；<br />
            3. 请严格按照要求上传附件，避免您的损失。
            </div>
          </van-cell-group>

        -->
        </div>
        <div class="other-box ">
          <van-row>
          <van-button type="submit" class="action" >保存</van-button>
                    </van-row>
        </div>
      </form>
                <van-actionsheet v-model="relationSheet"
            :actions="relationSheetActions " get-container=".page-wrap"
:close-on-click-overlay="false"/>

    </div>
</template>

<script>
import { NavBar,Button,Row,Col,Picker,Field,CellGroup,Toast,Checkbox,Actionsheet,CheckboxGroup,Cell,Uploader,Dialog } from 'vant';
import _ from 'lodash'
import Vue from 'vue';

import zhCN from 'vee-validate/dist/locale/zh_CN';
import VeeValidate, { Validator } from 'vee-validate';
import {check_card} from '../pages/util/common';

const dict = {
  zh_CN: {
    attributes: {
      name: "姓名",
      id_number: "身份证号码",
      phone: "电话号码",
      "id-front-image": "身份证正面照片",
      "id-back-image": "身份证背面照片",
    }
  }
}

Validator.localize(dict);
Validator.localize('zh_CN', zhCN);


Vue.use(VeeValidate);
Vue.use(Picker);
Vue.use(Actionsheet);

export default {
  components: {
    [NavBar.name]: NavBar,
    [Button.name]: Button,
    [Row.name]: Row,
    [Col.name]: Col,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [Toast.name]: Toast,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Uploader.name]: Uploader,
    [Cell.name]: Cell
  },
  props: ['message'],
  name: 'basicprofile',
  props: {
    editProfile: Object,
    defaultProfile: Object
  },
  computed: {
    hasEditProfile() {
      return !_.isEmpty(this.editProfile);
    }
  },
  data: function() {
    return {
      name: this.editProfile ? this.editProfile.name : "",
      phone: this.editProfile ? this.editProfile.phone : "",
      id_number: this.editProfile ? this.editProfile.id_number : "",
      idFront: this.editProfile ? this.editProfile.id_front : "",
      relation: this.editProfile ? this.editProfile.relation : "",
      idBack: this.editProfile ? this.editProfile.id_back : "",
      // 当用户信息下单支付成功时，不可修改身份证号，户口和姓名
      isEditoInfo: this.editProfile ? this.editProfile.hasPaidOrder : false,
      testImg: "",
      relationSheet: false,
      relationSheetActions: [
        {name:'爱人', callback: this.selectRelaction},
        {name:'父母', callback: this.selectRelaction},
        {name:'子女', callback: this.selectRelaction},
        {name:'兄弟', callback: this.selectRelaction},
        {name:'姐妹', callback: this.selectRelaction},
        {name:'同事', callback: this.selectRelaction},
        {name:'朋友', callback: this.selectRelaction},
        {name:'其他', callback: this.selectRelaction}
      ],
      hukou: {
        value: (this.editProfile ? this.editProfile.census_type === 'country' ? '农业户口' : '非农(城镇)户口' : '' ),
        show: false,
        actions: [
          {
            name: '非农(城镇)户口',
            callback: this.onHukouClick
          },
          {
            name: '农业户口',
            callback: this.onHukouClick
          }
        ]
      }
    }
  },
  mounted: function() {
    if (this.defaultProfile && !this.editProfile) {
      this.name = this.defaultProfile.name
      this.id_number = this.defaultProfile.id_number
      this.phone = this.defaultProfile.username
    }
    console.log(this.isEditoInfo)
  },
  methods: {
    clearScroll() {
      window.scroll(0, 0);
    },
    titleName: function() {
      return this.editProfile ? '修改参保人' : '新增参保人'
    },
    onHukouClick: function(item) {
      this.hukou.value = item.name
      this.hukou.show = false
    },
    selectRelaction(item) {
      this.relation = item.name
      this.relationSheet = false
    },
    onSubmit: function() {
      

      if (!/[\u4e00-\u9fa5]{2,6}/.test(this.name)) {
        Toast("姓名只能是中文");
        return;
      }

      if (!check_card(this.id_number)) {
        Toast("请输入正确身份证号码")
        return;
      }

      if (_.isEmpty(this.idFront)) {
        this.idFront = ''
      }

      if (_.isEmpty(this.idBack)) {
        this.idBack = ''
      }

      this.$validator.validate().then((result) => {
        if (result) {
          //身份证大写一下，避免小写的x
          let profile = {name: this.name, phone: this.phone, id_number: this.id_number.toUpperCase()};
          this.$http.post('/api/profile/save', {
            name: this.name,
            phone: this.phone,
            id_number: this.id_number.toUpperCase(),
            id_front: this.idFront,
            id_back: this.idBack,
            relation: this.relation,
            census_type: this.hukou.value == '农业户口' ? 'country' : 'city'
          }, {loading: true}).then(response => {
            if (response) {
              this.$hideLoading();
              let profile = response.data.data;
              this.$emit('saved', profile)
            }
            })

          
        } else {
          Toast(this.errors.items[0].msg);
        }
      }).catch(err => {
        Toast(err.message);
      })

      return false;
    },
    choosePhoto: function(e) {
      let files;  
      if (e.dataTransfer) {  
        files = e.dataTransfer.files;  
      } else if (e.target) {  
        files = e.target.files;  
      }  
      if (!files || files.length == 0) {
        return;
      }
      const reader = new FileReader();  
      reader.onload = () => {  
        this.idFront = reader.result;
      };  
      reader.readAsDataURL(files[0]);  
    },
    chooseBackPhoto: function(e) {
      let files;  
      if (e.dataTransfer) {  
        files = e.dataTransfer.files;  
      } else if (e.target) {  
        files = e.target.files;  
      }  
      if (!files || files.length == 0) {
        return;
      }
      const reader = new FileReader();  
      reader.onload = () => {  
        this.idBack = reader.result;
      };  
      reader.readAsDataURL(files[0]);       
    },
    onFrontChoose(result) {
      this.idFront = result.content;
    }, 
    onBackChoose(result) {
      this.idBack = result.content;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  @import "../assets/less/var.less";

  .page-swipe {
    padding-bottom: 30px;
  }
  .upload-icon {
    height: 300px;
    width: 300px;
    display: inline-block;
  }
  .tip {
    color: @defaultDescColor;
    padding: 10px;
    font-size: 12px;

  }
    
  div.tips, span.tips {
    text-align: left;
    font-size: 12px;
    color: @defaultDescColor;
    display: block;
    margin-bottom: 0px;
  }
  .photos-box {
    margin-top: 10px;
    text-align: center;
    padding: 20px;
  }
  .photo-label {
    font-size: 14px;
    text-align: left;
    display: block;
    margin-bottom: 15px;

  }
  .photo-box {
    border: 1px dashed #999;
    min-height: 90px;
    border-radius: 5px;

    &> .img-tip {
      margin-top: 25px;
      width: 25px;
      height: auto;
    }

    &> .img-id {
      width: 95%;
      height: auto;
      margin-top: 5px;
    }
    &> p {
      color: @defaultDescColor;
      font-size: 12px;
    }
  }
  .photo-row{
    padding: 0px 10px 15px 10px;

    &.first {
      border-bottom: 1px solid #f2f2f2;
      margin-bottom: 10px;
    }

    img.preview {
      width: auto;
      height: auto;
      max-width: 100%;
      max-height: 150px;
    }
  }
  .action {
     background-color: @defaultColor;
    color: white;
    border: 1px solid @defaultColor;
  }

  /*a  upload */
  .a-upload {
      cursor: pointer;
      color: #888;
      overflow: hidden;
      text-align: center;
      display: inline-block;
      *display: inline;
      *zoom: 1;
      width: 100%;
  }

  .a-upload  input {
      position: absolute;
      max-width: 50%;
      height: 120px;

      top: 30px;
      opacity: 0;
      filter: alpha(opacity=0);
      cursor: pointer;

      &.id-back-image {
        right: 0%;
        left: 50%;
        width: 50%;
      }

      &.id-front-image {
        right: 50%;
        width: 50%;
      }
  }

  .a-upload:hover {
      color: #444;
      background: #eee;
      border-color: #ccc;
      width: 100%;
      text-decoration: none;
  }

</style>



// WEBPACK FOOTER //
// src/components/sby-profile-edit.vue